// custom-radio-button.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, forwardRef, input, Signal, InputSignal, signal, WritableSignal, output, effect, OnInit } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';

export interface CustomRadioButtonOption {
  label: string;
  value: string;
  description?: string;
}

@Component({
  selector: 'app-custom-radio-button',
  templateUrl: './custom-radio-button.component.html',
  styleUrls: ['./custom-radio-button.component.scss'],
  standalone: true,
  imports: [MatRadioModule, FormsModule, CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomRadioButtonComponent),
      multi: true,
    },
  ],
})
export class CustomRadioButtonComponent implements ControlValueAccessor {
  options = input<CustomRadioButtonOption[]>([]);
  orientation = input('vertical');
  selectionChange = output<string>();

  selectedValue: WritableSignal<string | null> = signal(null);
  
  // Flag to distinguish between programmatic updates and user selections
  private isUserSelection = false;

  constructor() {
    effect(() => {
      const value = this.selectedValue();
      // Only emit selectionChange for actual user selections, not programmatic updates
      if (value !== null && this.isUserSelection) {
        this.selectionChange.emit(value);
        this.isUserSelection = false; // Reset flag after emitting
      }
    });
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: string): void {
    // This is a programmatic update, not a user selection
    this.isUserSelection = false;
    this.selectedValue.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectionChange(value: string): void {
    // This is a user selection
    this.isUserSelection = true;
    this.selectedValue.set(value);
    this.onChange(value);
    this.onTouched();
  }
}